import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { useAuthStore } from './stores/authStore'
import './styles/global.scss'

// Suppress harmless ResizeObserver errors from Vuetify components.
// This happens when the "Accommodation Types" select field changes size due to the user
// selecting a value.
const resizeObserverErrorHandler = (event) => {
  if (
    event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    event.message === 'ResizeObserver loop limit exceeded'
  ) {
    const isFromResizeObserver = event.filename === '' && event.lineno === 0 && event.colno === 0
    if (isFromResizeObserver) {
      event.stopImmediatePropagation()
      event.preventDefault()
    }
  }
}
window.addEventListener('error', resizeObserverErrorHandler)

// Alternative approach: Ignore all ResizeObserver errors
const debounce = (callback, delay) => {
  let tid
  return function (...args) {
    const ctx = this
    tid && clearTimeout(tid)
    tid = setTimeout(() => {
      callback.apply(ctx, args)
    }, delay)
  }
}

const _ = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ {
  constructor(callback) {
    callback = debounce(callback, 20)
    super(callback)
  }
}

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)

// Initialize auth store and mount app
const initializeApp = async () => {
  try {
    const authStore = useAuthStore()
    console.log('Initializing authentication...')
    await authStore.initialize()
    console.log('Authentication initialized, waiting for router...')
    await router.isReady()
    console.log('Router ready, mounting app')
    app.mount('#app')
  } catch (error) {
    console.error('Failed to initialize app:', error)
    // Mount app anyway to show error state
    await router.isReady()
    app.mount('#app')
  }
}

initializeApp()
